import { FC, ReactNode, useEffect, useState } from "react";
import { Box } from "@kamstrup/kfl";
import { MyKamstrupToolbar } from "../toolBar";
import rightImage from "./rightImage.png";
import { styles } from "./styles";

interface LayoutProps {
  children: ReactNode;
}

export const Layout: FC<LayoutProps> = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)");

    const handleChange = (e: MediaQueryListEvent | MediaQueryList) => setIsMobile(e.matches);

    handleChange(mediaQuery);

    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  return (
    <div style={styles.root}>
      <MyKamstrupToolbar />

      <div style={styles.mainContent}>
        <div style={styles.leftContent}>
          <Box sx={styles.leftContentBox}>{children}</Box>
        </div>

        {!isMobile && (
          <div style={styles.rightImageContainer}>
            <img alt="" src={rightImage} style={styles.rightImage} />
          </div>
        )}
      </div>
    </div>
  );
};
